import React from 'react';
import { motion } from 'framer-motion';
import './Testimonials.css';

const reviews = [
  {
    name: 'Asha R.',
    city: 'Bengaluru',
    date: 'Apr 2026',
    rating: 5,
    text: 'Amazing and reliable service. Highly recommend!',
    img: 'https://i.pravatar.cc/150?img=1'
  },
  {
    name: 'Rohit K.',
    city: 'Hyderabad',
    date: 'May 2026',
    rating: 5,
    text: 'Professional drivers and on-time every time.',
    img: 'https://i.pravatar.cc/150?img=2'
  },
  {
    name: 'Meera S.',
    city: 'Chennai',
    date: 'Jun 2026',
    rating: 5,
    text: 'Comfortable rides and safe drivers.',
    img: 'https://i.pravatar.cc/150?img=3'
  }
];

function Stars({n=5}){
  return <div className="g-stars" aria-hidden>{'★'.repeat(n)}{'☆'.repeat(5-n)}</div>
}

export default function Testimonials(){
  return (
    <section className="section testimonials">
      <motion.h2
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        Google Reviews
      </motion.h2>
      <motion.p
        className="reviews-sub"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.08 }}
      >
        What our customers say on Google
      </motion.p>

      <div className="reviews-grid">
        {reviews.map((r, idx) => (
          <motion.div
            className="review-card"
            key={idx}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.35 }}
            transition={{ duration: 0.5, delay: idx * 0.12 }}
            whileHover={{ y: -6 }}
          >
            <div className="review-left">
              <img src={r.img} alt={r.name} className="review-avatar" />
            </div>

            <div className="review-body">
              <div className="review-meta">
                <div className="review-name">{r.name}</div>
                <div className="review-date">{r.date} • {r.city}</div>
              </div>

              <Stars n={r.rating} />
              <p className="review-text">{r.text}</p>

              <div className="review-source">via Google</div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
